<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('expenseCategory.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('expenseCategory.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              v-tooltip="$t('expenseCategory.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.exp_cat_code }}</td>
          <td>{{ record.exp_category }}</td>
          <td>{{ record.exp_cat_desc }}</td>
          <td class="text-center ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('expenseCategory.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'expenseCategoryIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('expense/expenseCategory', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.expense.expenseCategory.search
      },
      set(newValue) {
        this.$store.commit('expense/expenseCategory/SET_SEARCH', newValue)
        this.$store.commit('expense/expenseCategory/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('expenseCategory.expenseCatCode') },
        { name: this.$t('expenseCategory.expenseCategoryName') },
        { name: this.$t('expenseCategory.expenseCategoryDescription') },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('expense/expenseCategory/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('expense/expenseCategory/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
       this.$store.commit('expense/expenseCategory/SET_EDIT_DATA', {})
      this.showForm = false
		},
		deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('expense/expenseCategory/destroy', record.exp_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('expense/expenseCategory/RESET_STATE')
    next()
  }
}
</script>
